export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      label: '登录',
      hidden: true,
    },
    component: loadView('views/login/login'),
  },
]

function loadView(path) {
  return () => import(/* webpackChunkName: "chunk-[request][index]" */ `@/${path}`)
}
